import React, { createContext, useState } from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import { Login } from '../auth/Login';
import { Register } from '../auth/Register';
import { ForgotPassword } from '../auth/ForgotPassword';
import ProtectedRoute from './ProtectedRoute';
import DashboardLayout from '../Dashboard/DashboardLayout';
import PaymentSuccess from '../Dashboard/Db/Explore/PaymentSuccess';
import PaymentFailed from '../Dashboard/Db/Explore/PaymentFailed';
import PrivacyPolicy from '../Dashboard/Db/PrivacyPolicy';
import OrderFailed from '../Dashboard/Db/Explore/OrderFailed';
import ActivateAccount from '../Dashboard/Db/ActivateAccount';
import LandingPage from '../../components/LandingPage';
import HealthCareFacilities from '../../components/HealthCareFacilities';
import CartList from '../Dashboard/Db/Cart/NewCartList';
import MapView from '../MapView';
import { toast } from 'react-toastify';
import AboutUs from '../../components/AboutUs';
import { CartLogin } from '../auth/CartLogin';
import SharedCart from '../Dashboard/Db/Cart/SharedCart';
import { getSession } from '../redux/actions/authActions';
import { SharedLogin } from '../auth/SharedLogin';

export const CartContext = createContext({
  cartItems: [],
  handleCartItems: () => {},
});

export const Router = () => {
  const { token } = getSession();

  const [cartItems, setCartItems] = useState(
    localStorage.getItem('cartData')
      ? JSON.parse(localStorage.getItem('cartData'))
      : []
  );
  const handleCartItems = (data) => {
    setCartItems(data);
    localStorage.setItem('cartData', JSON.stringify(data));
    toast.success('Shopping cart update successful');
  };
  return (
    <div>
      <CartContext.Provider value={{ cartItems, handleCartItems }}>
        <BrowserRouter basename="">
          <Switch>
            <Route exact path={`/`} component={LandingPage} />
            <Route
              exact
              path={`/facilities`}
              render={(props) => (
                <HealthCareFacilities
                  {...props}
                  page=""
                  cartItems={cartItems}
                  handleCartItems={handleCartItems}
                />
              )}
            />
            <Route exact path={`/about-us`} component={AboutUs} />
            <Route exact path={`/cart`} component={CartList} />
            <Route exact path={`/share_payment`} component={SharedCart} />
            <Route exact path={`/register`} component={Register} />
            <Route exact path={`/login`} component={Login} />
            <Route exact path={`/sharedLogin`} component={SharedLogin} />
            <Route exact path={`/cartLogin`} component={CartLogin} />
            <Route exact path={`/forgotpassword`} component={ForgotPassword} />
            <Route
              exact
              path={`/map`}
              render={(props) => (
                <MapView
                  {...props}
                  cartItems={cartItems}
                  handleCartItems={handleCartItems}
                />
              )}
            />
            <Route exact path={`/payment-success`} component={PaymentSuccess} />
            <Route exact path={`/payment-failure`} component={PaymentFailed} />
            <Route
              exact
              path={`/payment-order-failure`}
              component={OrderFailed}
            />
            <Route exact path={`/privacy-policy`} component={PrivacyPolicy} />
            <Route exact path={`/activate`} component={ActivateAccount} />
            <ProtectedRoute path={`/dashboard/`} component={DashboardLayout} />
            <Route
              component={() => (
                <Redirect to={token ? '/dashboard' : '/'} replace={true} />
              )}
            />
          </Switch>
        </BrowserRouter>
      </CartContext.Provider>
    </div>
  );
};
